declare const buildInfo: {
    git_commit: string;
    job_name: string;
    build_id: string;
};

export function getBuildInfo() {
    return buildInfo;
}
